module.exports = __webpack_public_path__ + "img/About_12.478ae194.png";